// src/data/lateOne.js
//
// LATE-1 - THE APPROVED MEMBER-FACING TEXT ON EXTENDING A TIME LIMIT (ruling 164; task list section 354).
//
// PROVENANCE. Drafted 2026-09-16, approved by Bob the same day ("All recommendations approval"; "1, 2, 3, 4
// all okay"). The record then carried it as LOST for six days - ruling 164 and the master list both said it
// lived "in chat" and could not be reached. It was recovered on 2026-09-22 by the five-day sweep and filed
// at `data\YCP_LATE-1_MEMBER_TEXT_APPROVED_2026-09-16.md`. This module is that text, on a screen at last.
//
// ONE SOURCE. `scripts\test-late1.mjs` compares these lines, character for character, against the filed
// file. Change the words HERE and in the file, and only on Bob's say-so: they are his, not the platform's.
//
// WHAT IT IS NOT. It is not advice about his claim (ruling 204: the platform never assesses his position),
// and it is not a promise that an extension will be granted. It states what makes a request timely, and it
// recommends representation - which is the Organization's own view, stated as such.

export const LATE1_TITLE = 'Extending a time limit yourself';

export const LATE1_INTRO =
  'You have the right to represent yourself. You may request an extension of a time limit on your own, without union representation. Your request is on time if it is:';

export const LATE1_CONDITIONS = Object.freeze([
  'in writing,',
  'made as your controlling agreement requires,',
  'submitted before the time limit expires, and',
  'provable, so keep your timestamp or receipt.',
]);

export const LATE1_CARRIER_LINE =
  "The carrier's answer does not decide whether your request was on time.";

export const LATE1_RECOMMENDATION_TITLE = 'Our recommendation';

export const LATE1_RECOMMENDATION = Object.freeze([
  'Handling this alone is not the recommended course. Once you hand your claim to your representative to pursue with the carrier, work with that representative on any extension.',
  'The facts you state are yours. You may change or withdraw them at any time, but you must tell your representative and your General Chairman right away.',
  'Enforcement of your agreement rests with your General Chairman.',
]);

export const LATE1_WHY_TITLE = 'Why we recommend representation';

export const LATE1_WHY =
  'While we have done our best to reduce errors, AI is known to make errors and is not to be trusted, including this very app.';

// Every line, in the order it is shown - the suite walks this to prove the file holds each one.
export function late1Lines() {
  return [LATE1_TITLE, LATE1_INTRO].concat(LATE1_CONDITIONS)
    .concat([LATE1_CARRIER_LINE, LATE1_RECOMMENDATION_TITLE])
    .concat(LATE1_RECOMMENDATION)
    .concat([LATE1_WHY_TITLE, LATE1_WHY]);
}
